import { useAccount, useMsal } from '@azure/msal-react';
import { useAsyncEffect } from 'hooks/UseAsyncEffect';
import { loginRequest, protectedResources } from 'authConfig';
import { useState } from 'react';
import { AccountInfo } from '@azure/msal-browser';

export function useAuth(): Auth {
    const [bearerToken, setBearerToken] = useState<string>('');
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    useAsyncEffect(async () => {
        if (account) {
            const token = await instance.acquireTokenSilent({
                scopes: protectedResources.apiTemplates.scopes,
                account: account,
            });
            setBearerToken('Bearer ' + token.accessToken);
        } else {
            // TODO forward to login
        }
    }, []);

    return {
        getBearerToken: (): string => {
            return bearerToken;
        },
        login: (): void => {
            instance.loginRedirect(loginRequest).catch((e) => {
                console.error(e);
            });
        },
        logout: (): void => {
            instance.logoutRedirect().catch((e) => {
                console.error(e);
            });
        },
        getAccount: (): AccountInfo | null => {
            return account;
        },
        isLoggedIn: !!account,
    };
}

export interface Auth {
    getBearerToken: () => string;
    login: () => void;
    logout: () => void;
    getAccount: () => AccountInfo | null;
    isLoggedIn: boolean;
}
